import * as React from 'react';
import { NavLink as RRNavLink } from 'react-router-dom';
import { NavLink } from 'reactstrap';

export interface ICustomNavLinkProps {
    to: string;
    onClick?: (event) => void;
}

export class CustomNavLink extends React.PureComponent<ICustomNavLinkProps, {}> {
    constructor(props: ICustomNavLinkProps) {
        super(props);
    }

    public render() {
        const { to, onClick, children } = this.props;
        return <NavLink to={to} onClick={onClick} activeClassName={to === '/' ? '' : 'active'} tag={RRNavLink}>
            {children}
        </NavLink>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Navbar/CustomNavLink.tsx